import {
  Component,
  HostListener, Inject,
  Input, PLATFORM_ID
} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {
  EVENT_CALENDAR_ROUTE,
  LOGIN_ROUTE,
} from "src/app/app-routing.module";
import {
  alphabetical,
  email,
  max_length_45,
  max_length_50,
  passwordStrengthValidator,
  required,
  requiredTrue
} from '@utility';
import {AbstractComponent, ConsentComponent} from "@components";
import {Lookups, RegisterUser} from "@model";
import {AuthenticationService} from "@services";
import {isPlatformBrowser} from "@angular/common";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent extends AbstractComponent {
  @Input() genders: Lookups[] = [];

  signupComponentState: SignupComponentState = SignupComponentState.INITIAL;
  signupComponentError: number | undefined;

  inputForm: FormGroup<{
    firstName: FormControl<string | null>;
    lastName: FormControl<string | null>;
    password: FormControl<string | null>;
    gender: FormControl<string | null>;
    email: FormControl<string | null>;
    termsAndConditionsAccepted: FormControl<boolean | null>;
  }> = new FormGroup({
    email: new FormControl('', [
        required,
        email,
        max_length_50
      ]
    ),
    password: new FormControl('', [
      required,
      passwordStrengthValidator()
    ]),
    firstName: new FormControl('', [
      required,
      alphabetical,
      max_length_45
    ]),
    lastName: new FormControl('', [
      required,
      alphabetical,
      max_length_45
    ]),
    gender: new FormControl('', []),
    termsAndConditionsAccepted: new FormControl(false, [requiredTrue])
  });

  public currentWindowWidth: number = 0;
  private isBrowser: boolean;

  constructor(private authService: AuthenticationService, @Inject(PLATFORM_ID) private platformId: Object,
              private router: Router,  private modalService: NgbModal) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit() {
    this.inputForm.controls.termsAndConditionsAccepted.disable();
    this.subscriptions.push(this.inputForm.controls.termsAndConditionsAccepted.valueChanges.subscribe(val => {
      if (val) {
        this.inputForm.controls.termsAndConditionsAccepted.enable({emitEvent:false})
      }
      else {
        this.inputForm.controls.termsAndConditionsAccepted.disable({emitEvent:false})
      }
      this.inputForm.updateValueAndValidity()
    }));
  }



  setInitialState() {
    this.markAllAsUntouched(this.inputForm);
    this.inputForm.controls.email.setValue("");
    this.inputForm.controls.password.setValue("")
    this.inputForm.controls.firstName.setValue("");
    this.inputForm.controls.firstName.setValue("");
    this.inputForm.controls.gender.setValue("");
    this.signupComponentState = SignupComponentState.INITIAL;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  onRegister(): void {
    if (!this.inputForm.valid || !this.inputForm.controls.termsAndConditionsAccepted.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
      this.authService.signUp(new RegisterUser(
              this.inputForm.value.email,
              this.inputForm.value.password,
              this.inputForm.value.firstName,
              this.inputForm.value.lastName,
              this.inputForm.value.gender,
              this.inputForm.controls.termsAndConditionsAccepted.value),
          () => {
            this.signupComponentState = SignupComponentState.SUCCESS;

          }, (errorCode: number) => {
            this.signupComponentState = SignupComponentState.ERROR;
            this.signupComponentError = errorCode;
          });

  }

  onSignup(): void {
    this.signupComponentState = SignupComponentState.SIGNUP;
  }

  openConsentModal(open?: boolean | undefined) {
    if (!this.inputForm.controls.termsAndConditionsAccepted.value || open) {
      const modalRef: NgbModalRef = this.modalService.open(ConsentComponent, {
        centered: true,
        size: 'xl',
        scrollable: true
      });
      modalRef.componentInstance.isProfile = true;
      modalRef.result.then(() => {
        this.inputForm.controls.termsAndConditionsAccepted.setValue(true);
      })
    }
  }


  toLogin(): void {
    this.router.navigate([LOGIN_ROUTE]);
  }

  onFacebookLogin(): void {
    this.authService.facebookSignIn();
  }

  toHome(): void {
    this.router.navigate([EVENT_CALENDAR_ROUTE]);
  }

  protected readonly SignupComponentState = SignupComponentState;
}

enum SignupComponentState {
  INITIAL,
  SIGNUP,
  SUCCESS,
  ERROR,
}
